import React from "react";
import "./styles/previewPhone.sass";

interface IPreviewPhoneProps {
    phoneNumber: string;
    previewTextMessage: string;
    drawerOpenPadding: boolean;
    showDisclaimer: boolean;
    overrideWidth?: string;
    onClickMessageBox?: () => void;
}

const PreviewPhone: React.FC<IPreviewPhoneProps> = ({
    phoneNumber,
    previewTextMessage,
    drawerOpenPadding,
    showDisclaimer = true,
    overrideWidth,
    onClickMessageBox
}) => {
    return (              
        <div className="preview-phone-container" style={{paddingRight: drawerOpenPadding ? "468px" : 0}}>
            <div className="phone-outline" style={{width: overrideWidth ? overrideWidth : ""}}>
                <div className="phone-header">
                    <div className="dot-line-container">
                        <div className="dot"/>
                        <div className="line"/>
                    </div>
                    <div className="phone-number-container">
                        {phoneNumber}
                    </div>
                </div>

                {previewTextMessage && 
                    <div className="message-box"
                        onClick={onClickMessageBox}
                    >
                        <span className="message">
                            {previewTextMessage}
                        </span>
                    </div>
                }

                <div className="bottom-bar">
                    <div className="bottom-bar-fill"/>
                </div>
            </div>
            {showDisclaimer &&
                <div className="sms-disclaimer">
                    Actual SMS apprearance varies per recipient and device.
                </div>
            }
        </div>
    )
};

export default PreviewPhone;